
import PropTypes from 'prop-types';

import React, {Component} from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


export default class NullCheckboxWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
  };

  handleChange = (value) => {
    const { onChange } = this.props;
    onChange(value);
  };

  render() {
    const { label } = this.props;
    let { value } = this.props;

    if (typeof value === 'string') {
      switch (value) {
        case 'true':
          value = true;
          break;
        case 'false':
          value = false;
          break;
        default:
          value = undefined;
      }
    }
    else if (value === undefined || value === null || typeof value !== 'boolean') {
      value = undefined;
    }

    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={value === undefined ? false : value}
            indeterminate={value === false}
            onChange={(e) => this.handleChange(value === false ? null : e.target.checked)}
          />
        }
        label={label}
      />
    )
  }
}

